export enum PLUGIN_EVENT_TYPE {
	Requested = 0,
	Activated = 1,
	Desactivated = 2,
}
